import { default as app_45tncjm1KRSUCyuMeta } from "/github/workspace/pages/app-tnc.vue?macro=true";
import { default as articlesaEazpkBKt0Meta } from "/github/workspace/pages/articles.vue?macro=true";
import { default as articlesBookmark5OzEv26tE4Meta } from "/github/workspace/pages/articlesBookmark.vue?macro=true";
import { default as articlesDetailOpaXnshOz0Meta } from "/github/workspace/pages/articlesDetail.vue?macro=true";
import { default as breathingbYmQkLGXD9Meta } from "/github/workspace/pages/breathing.vue?macro=true";
import { default as challengewmibj3quA0Meta } from "/github/workspace/pages/challenge.vue?macro=true";
import { default as challengeDetailYClhm7mcCJMeta } from "/github/workspace/pages/challengeDetail.vue?macro=true";
import { default as entryzHyE1YUAhvMeta } from "/github/workspace/pages/entry.vue?macro=true";
import { default as homeIjGB0ROS1CMeta } from "/github/workspace/pages/home.vue?macro=true";
import { default as indexhKnGp5KL0kMeta } from "/github/workspace/pages/index.vue?macro=true";
import { default as picsqq1yLaCZixMeta } from "/github/workspace/pages/pics.vue?macro=true";
import { default as postMsgTestHlECoyRQpBMeta } from "/github/workspace/pages/postMsgTest.vue?macro=true";
import { default as privacy_45policyETFUUrN3XBMeta } from "/github/workspace/pages/privacy-policy.vue?macro=true";
import { default as privacyPolicyIHYHmtszSbMeta } from "/github/workspace/pages/privacyPolicy.vue?macro=true";
import { default as stepCountChangeDevicecJxXov1yQbMeta } from "/github/workspace/pages/stepCountChangeDevice.vue?macro=true";
import { default as stepCountConnectIntroOEUwHh3fKSMeta } from "/github/workspace/pages/stepCountConnectIntro.vue?macro=true";
import { default as stepCountConnectListxKHEc7Nw3SMeta } from "/github/workspace/pages/stepCountConnectList.vue?macro=true";
import { default as stepCountConnectedsBiDYHv5YHMeta } from "/github/workspace/pages/stepCountConnected.vue?macro=true";
import { default as stepCountDisconnectedxSHVfZoJL9Meta } from "/github/workspace/pages/stepCountDisconnected.vue?macro=true";
import { default as stepCountGarminConnected0DX7mE7VLPMeta } from "/github/workspace/pages/stepCountGarminConnected.vue?macro=true";
import { default as stepCountIntroi6psBPi60AMeta } from "/github/workspace/pages/stepCountIntro.vue?macro=true";
import { default as stretch0dYh64TgGTMeta } from "/github/workspace/pages/stretch.vue?macro=true";
import { default as stretchTestJR4C8A5r3dMeta } from "/github/workspace/pages/stretchTest.vue?macro=true";
import { default as terms_45and_45conditionsoOl0T86Y7QMeta } from "/github/workspace/pages/terms-and-conditions.vue?macro=true";
import { default as tncmCmlhL6PlwMeta } from "/github/workspace/pages/tnc.vue?macro=true";
import { default as vitalResultm6JhYmZflfMeta } from "/github/workspace/pages/vitalResult.vue?macro=true";
import { default as vitalResultDetailPZQAZcipmBMeta } from "/github/workspace/pages/vitalResultDetail.vue?macro=true";
import { default as vitalScantuGqe0PARyMeta } from "/github/workspace/pages/vitalScan.vue?macro=true";
import { default as vitalScanDis4w1UeRXroAMeta } from "/github/workspace/pages/vitalScanDis.vue?macro=true";
import { default as vitalScanOriginalkRdMcdCBgvMeta } from "/github/workspace/pages/vitalScanOriginal.vue?macro=true";
export default [
  {
    name: app_45tncjm1KRSUCyuMeta?.name ?? "app-tnc___en___default",
    path: app_45tncjm1KRSUCyuMeta?.path ?? "/app-tnc",
    meta: app_45tncjm1KRSUCyuMeta || {},
    alias: app_45tncjm1KRSUCyuMeta?.alias || [],
    redirect: app_45tncjm1KRSUCyuMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/app-tnc.vue").then(m => m.default || m)
  },
  {
    name: app_45tncjm1KRSUCyuMeta?.name ?? "app-tnc___en",
    path: app_45tncjm1KRSUCyuMeta?.path ?? "/en/app-tnc",
    meta: app_45tncjm1KRSUCyuMeta || {},
    alias: app_45tncjm1KRSUCyuMeta?.alias || [],
    redirect: app_45tncjm1KRSUCyuMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/app-tnc.vue").then(m => m.default || m)
  },
  {
    name: app_45tncjm1KRSUCyuMeta?.name ?? "app-tnc___tc",
    path: app_45tncjm1KRSUCyuMeta?.path ?? "/tc/app-tnc",
    meta: app_45tncjm1KRSUCyuMeta || {},
    alias: app_45tncjm1KRSUCyuMeta?.alias || [],
    redirect: app_45tncjm1KRSUCyuMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/app-tnc.vue").then(m => m.default || m)
  },
  {
    name: articlesaEazpkBKt0Meta?.name ?? "articles___en___default",
    path: articlesaEazpkBKt0Meta?.path ?? "/articles",
    meta: articlesaEazpkBKt0Meta || {},
    alias: articlesaEazpkBKt0Meta?.alias || [],
    redirect: articlesaEazpkBKt0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesaEazpkBKt0Meta?.name ?? "articles___en",
    path: articlesaEazpkBKt0Meta?.path ?? "/en/articles",
    meta: articlesaEazpkBKt0Meta || {},
    alias: articlesaEazpkBKt0Meta?.alias || [],
    redirect: articlesaEazpkBKt0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesaEazpkBKt0Meta?.name ?? "articles___tc",
    path: articlesaEazpkBKt0Meta?.path ?? "/tc/articles",
    meta: articlesaEazpkBKt0Meta || {},
    alias: articlesaEazpkBKt0Meta?.alias || [],
    redirect: articlesaEazpkBKt0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesBookmark5OzEv26tE4Meta?.name ?? "articlesBookmark___en___default",
    path: articlesBookmark5OzEv26tE4Meta?.path ?? "/articlesBookmark",
    meta: articlesBookmark5OzEv26tE4Meta || {},
    alias: articlesBookmark5OzEv26tE4Meta?.alias || [],
    redirect: articlesBookmark5OzEv26tE4Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesBookmark.vue").then(m => m.default || m)
  },
  {
    name: articlesBookmark5OzEv26tE4Meta?.name ?? "articlesBookmark___en",
    path: articlesBookmark5OzEv26tE4Meta?.path ?? "/en/articlesBookmark",
    meta: articlesBookmark5OzEv26tE4Meta || {},
    alias: articlesBookmark5OzEv26tE4Meta?.alias || [],
    redirect: articlesBookmark5OzEv26tE4Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesBookmark.vue").then(m => m.default || m)
  },
  {
    name: articlesBookmark5OzEv26tE4Meta?.name ?? "articlesBookmark___tc",
    path: articlesBookmark5OzEv26tE4Meta?.path ?? "/tc/articlesBookmark",
    meta: articlesBookmark5OzEv26tE4Meta || {},
    alias: articlesBookmark5OzEv26tE4Meta?.alias || [],
    redirect: articlesBookmark5OzEv26tE4Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesBookmark.vue").then(m => m.default || m)
  },
  {
    name: articlesDetailOpaXnshOz0Meta?.name ?? "articlesDetail___en___default",
    path: articlesDetailOpaXnshOz0Meta?.path ?? "/articlesDetail",
    meta: articlesDetailOpaXnshOz0Meta || {},
    alias: articlesDetailOpaXnshOz0Meta?.alias || [],
    redirect: articlesDetailOpaXnshOz0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesDetail.vue").then(m => m.default || m)
  },
  {
    name: articlesDetailOpaXnshOz0Meta?.name ?? "articlesDetail___en",
    path: articlesDetailOpaXnshOz0Meta?.path ?? "/en/articlesDetail",
    meta: articlesDetailOpaXnshOz0Meta || {},
    alias: articlesDetailOpaXnshOz0Meta?.alias || [],
    redirect: articlesDetailOpaXnshOz0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesDetail.vue").then(m => m.default || m)
  },
  {
    name: articlesDetailOpaXnshOz0Meta?.name ?? "articlesDetail___tc",
    path: articlesDetailOpaXnshOz0Meta?.path ?? "/tc/articlesDetail",
    meta: articlesDetailOpaXnshOz0Meta || {},
    alias: articlesDetailOpaXnshOz0Meta?.alias || [],
    redirect: articlesDetailOpaXnshOz0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/articlesDetail.vue").then(m => m.default || m)
  },
  {
    name: breathingbYmQkLGXD9Meta?.name ?? "breathing___en___default",
    path: breathingbYmQkLGXD9Meta?.path ?? "/breathing",
    meta: breathingbYmQkLGXD9Meta || {},
    alias: breathingbYmQkLGXD9Meta?.alias || [],
    redirect: breathingbYmQkLGXD9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/breathing.vue").then(m => m.default || m)
  },
  {
    name: breathingbYmQkLGXD9Meta?.name ?? "breathing___en",
    path: breathingbYmQkLGXD9Meta?.path ?? "/en/breathing",
    meta: breathingbYmQkLGXD9Meta || {},
    alias: breathingbYmQkLGXD9Meta?.alias || [],
    redirect: breathingbYmQkLGXD9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/breathing.vue").then(m => m.default || m)
  },
  {
    name: breathingbYmQkLGXD9Meta?.name ?? "breathing___tc",
    path: breathingbYmQkLGXD9Meta?.path ?? "/tc/breathing",
    meta: breathingbYmQkLGXD9Meta || {},
    alias: breathingbYmQkLGXD9Meta?.alias || [],
    redirect: breathingbYmQkLGXD9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/breathing.vue").then(m => m.default || m)
  },
  {
    name: challengewmibj3quA0Meta?.name ?? "challenge___en___default",
    path: challengewmibj3quA0Meta?.path ?? "/challenge",
    meta: challengewmibj3quA0Meta || {},
    alias: challengewmibj3quA0Meta?.alias || [],
    redirect: challengewmibj3quA0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challenge.vue").then(m => m.default || m)
  },
  {
    name: challengewmibj3quA0Meta?.name ?? "challenge___en",
    path: challengewmibj3quA0Meta?.path ?? "/en/challenge",
    meta: challengewmibj3quA0Meta || {},
    alias: challengewmibj3quA0Meta?.alias || [],
    redirect: challengewmibj3quA0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challenge.vue").then(m => m.default || m)
  },
  {
    name: challengewmibj3quA0Meta?.name ?? "challenge___tc",
    path: challengewmibj3quA0Meta?.path ?? "/tc/challenge",
    meta: challengewmibj3quA0Meta || {},
    alias: challengewmibj3quA0Meta?.alias || [],
    redirect: challengewmibj3quA0Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challenge.vue").then(m => m.default || m)
  },
  {
    name: challengeDetailYClhm7mcCJMeta?.name ?? "challengeDetail___en___default",
    path: challengeDetailYClhm7mcCJMeta?.path ?? "/challengeDetail",
    meta: challengeDetailYClhm7mcCJMeta || {},
    alias: challengeDetailYClhm7mcCJMeta?.alias || [],
    redirect: challengeDetailYClhm7mcCJMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challengeDetail.vue").then(m => m.default || m)
  },
  {
    name: challengeDetailYClhm7mcCJMeta?.name ?? "challengeDetail___en",
    path: challengeDetailYClhm7mcCJMeta?.path ?? "/en/challengeDetail",
    meta: challengeDetailYClhm7mcCJMeta || {},
    alias: challengeDetailYClhm7mcCJMeta?.alias || [],
    redirect: challengeDetailYClhm7mcCJMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challengeDetail.vue").then(m => m.default || m)
  },
  {
    name: challengeDetailYClhm7mcCJMeta?.name ?? "challengeDetail___tc",
    path: challengeDetailYClhm7mcCJMeta?.path ?? "/tc/challengeDetail",
    meta: challengeDetailYClhm7mcCJMeta || {},
    alias: challengeDetailYClhm7mcCJMeta?.alias || [],
    redirect: challengeDetailYClhm7mcCJMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/challengeDetail.vue").then(m => m.default || m)
  },
  {
    name: entryzHyE1YUAhvMeta?.name ?? "entry___en___default",
    path: entryzHyE1YUAhvMeta?.path ?? "/entry",
    meta: entryzHyE1YUAhvMeta || {},
    alias: entryzHyE1YUAhvMeta?.alias || [],
    redirect: entryzHyE1YUAhvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/entry.vue").then(m => m.default || m)
  },
  {
    name: entryzHyE1YUAhvMeta?.name ?? "entry___en",
    path: entryzHyE1YUAhvMeta?.path ?? "/en/entry",
    meta: entryzHyE1YUAhvMeta || {},
    alias: entryzHyE1YUAhvMeta?.alias || [],
    redirect: entryzHyE1YUAhvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/entry.vue").then(m => m.default || m)
  },
  {
    name: entryzHyE1YUAhvMeta?.name ?? "entry___tc",
    path: entryzHyE1YUAhvMeta?.path ?? "/tc/entry",
    meta: entryzHyE1YUAhvMeta || {},
    alias: entryzHyE1YUAhvMeta?.alias || [],
    redirect: entryzHyE1YUAhvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/entry.vue").then(m => m.default || m)
  },
  {
    name: homeIjGB0ROS1CMeta?.name ?? "home___en___default",
    path: homeIjGB0ROS1CMeta?.path ?? "/home",
    meta: homeIjGB0ROS1CMeta || {},
    alias: homeIjGB0ROS1CMeta?.alias || [],
    redirect: homeIjGB0ROS1CMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/home.vue").then(m => m.default || m)
  },
  {
    name: homeIjGB0ROS1CMeta?.name ?? "home___en",
    path: homeIjGB0ROS1CMeta?.path ?? "/en/home",
    meta: homeIjGB0ROS1CMeta || {},
    alias: homeIjGB0ROS1CMeta?.alias || [],
    redirect: homeIjGB0ROS1CMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/home.vue").then(m => m.default || m)
  },
  {
    name: homeIjGB0ROS1CMeta?.name ?? "home___tc",
    path: homeIjGB0ROS1CMeta?.path ?? "/tc/home",
    meta: homeIjGB0ROS1CMeta || {},
    alias: homeIjGB0ROS1CMeta?.alias || [],
    redirect: homeIjGB0ROS1CMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/home.vue").then(m => m.default || m)
  },
  {
    name: indexhKnGp5KL0kMeta?.name ?? "index___en___default",
    path: indexhKnGp5KL0kMeta?.path ?? "/",
    meta: indexhKnGp5KL0kMeta || {},
    alias: indexhKnGp5KL0kMeta?.alias || [],
    redirect: indexhKnGp5KL0kMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexhKnGp5KL0kMeta?.name ?? "index___en",
    path: indexhKnGp5KL0kMeta?.path ?? "/en",
    meta: indexhKnGp5KL0kMeta || {},
    alias: indexhKnGp5KL0kMeta?.alias || [],
    redirect: indexhKnGp5KL0kMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexhKnGp5KL0kMeta?.name ?? "index___tc",
    path: indexhKnGp5KL0kMeta?.path ?? "/tc",
    meta: indexhKnGp5KL0kMeta || {},
    alias: indexhKnGp5KL0kMeta?.alias || [],
    redirect: indexhKnGp5KL0kMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/index.vue").then(m => m.default || m)
  },
  {
    name: picsqq1yLaCZixMeta?.name ?? "pics___en___default",
    path: picsqq1yLaCZixMeta?.path ?? "/pics",
    meta: picsqq1yLaCZixMeta || {},
    alias: picsqq1yLaCZixMeta?.alias || [],
    redirect: picsqq1yLaCZixMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/pics.vue").then(m => m.default || m)
  },
  {
    name: picsqq1yLaCZixMeta?.name ?? "pics___en",
    path: picsqq1yLaCZixMeta?.path ?? "/en/pics",
    meta: picsqq1yLaCZixMeta || {},
    alias: picsqq1yLaCZixMeta?.alias || [],
    redirect: picsqq1yLaCZixMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/pics.vue").then(m => m.default || m)
  },
  {
    name: picsqq1yLaCZixMeta?.name ?? "pics___tc",
    path: picsqq1yLaCZixMeta?.path ?? "/tc/pics",
    meta: picsqq1yLaCZixMeta || {},
    alias: picsqq1yLaCZixMeta?.alias || [],
    redirect: picsqq1yLaCZixMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/pics.vue").then(m => m.default || m)
  },
  {
    name: postMsgTestHlECoyRQpBMeta?.name ?? "postMsgTest___en___default",
    path: postMsgTestHlECoyRQpBMeta?.path ?? "/postMsgTest",
    meta: postMsgTestHlECoyRQpBMeta || {},
    alias: postMsgTestHlECoyRQpBMeta?.alias || [],
    redirect: postMsgTestHlECoyRQpBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/postMsgTest.vue").then(m => m.default || m)
  },
  {
    name: postMsgTestHlECoyRQpBMeta?.name ?? "postMsgTest___en",
    path: postMsgTestHlECoyRQpBMeta?.path ?? "/en/postMsgTest",
    meta: postMsgTestHlECoyRQpBMeta || {},
    alias: postMsgTestHlECoyRQpBMeta?.alias || [],
    redirect: postMsgTestHlECoyRQpBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/postMsgTest.vue").then(m => m.default || m)
  },
  {
    name: postMsgTestHlECoyRQpBMeta?.name ?? "postMsgTest___tc",
    path: postMsgTestHlECoyRQpBMeta?.path ?? "/tc/postMsgTest",
    meta: postMsgTestHlECoyRQpBMeta || {},
    alias: postMsgTestHlECoyRQpBMeta?.alias || [],
    redirect: postMsgTestHlECoyRQpBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/postMsgTest.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyETFUUrN3XBMeta?.name ?? "privacy-policy___en___default",
    path: privacy_45policyETFUUrN3XBMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyETFUUrN3XBMeta || {},
    alias: privacy_45policyETFUUrN3XBMeta?.alias || [],
    redirect: privacy_45policyETFUUrN3XBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyETFUUrN3XBMeta?.name ?? "privacy-policy___en",
    path: privacy_45policyETFUUrN3XBMeta?.path ?? "/en/privacy-policy",
    meta: privacy_45policyETFUUrN3XBMeta || {},
    alias: privacy_45policyETFUUrN3XBMeta?.alias || [],
    redirect: privacy_45policyETFUUrN3XBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyETFUUrN3XBMeta?.name ?? "privacy-policy___tc",
    path: privacy_45policyETFUUrN3XBMeta?.path ?? "/tc/privacy-policy",
    meta: privacy_45policyETFUUrN3XBMeta || {},
    alias: privacy_45policyETFUUrN3XBMeta?.alias || [],
    redirect: privacy_45policyETFUUrN3XBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacyPolicyIHYHmtszSbMeta?.name ?? "privacyPolicy___en___default",
    path: privacyPolicyIHYHmtszSbMeta?.path ?? "/privacyPolicy",
    meta: privacyPolicyIHYHmtszSbMeta || {},
    alias: privacyPolicyIHYHmtszSbMeta?.alias || [],
    redirect: privacyPolicyIHYHmtszSbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacyPolicy.vue").then(m => m.default || m)
  },
  {
    name: privacyPolicyIHYHmtszSbMeta?.name ?? "privacyPolicy___en",
    path: privacyPolicyIHYHmtszSbMeta?.path ?? "/en/privacyPolicy",
    meta: privacyPolicyIHYHmtszSbMeta || {},
    alias: privacyPolicyIHYHmtszSbMeta?.alias || [],
    redirect: privacyPolicyIHYHmtszSbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacyPolicy.vue").then(m => m.default || m)
  },
  {
    name: privacyPolicyIHYHmtszSbMeta?.name ?? "privacyPolicy___tc",
    path: privacyPolicyIHYHmtszSbMeta?.path ?? "/tc/privacyPolicy",
    meta: privacyPolicyIHYHmtszSbMeta || {},
    alias: privacyPolicyIHYHmtszSbMeta?.alias || [],
    redirect: privacyPolicyIHYHmtszSbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/privacyPolicy.vue").then(m => m.default || m)
  },
  {
    name: stepCountChangeDevicecJxXov1yQbMeta?.name ?? "stepCountChangeDevice___en___default",
    path: stepCountChangeDevicecJxXov1yQbMeta?.path ?? "/stepCountChangeDevice",
    meta: stepCountChangeDevicecJxXov1yQbMeta || {},
    alias: stepCountChangeDevicecJxXov1yQbMeta?.alias || [],
    redirect: stepCountChangeDevicecJxXov1yQbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountChangeDevice.vue").then(m => m.default || m)
  },
  {
    name: stepCountChangeDevicecJxXov1yQbMeta?.name ?? "stepCountChangeDevice___en",
    path: stepCountChangeDevicecJxXov1yQbMeta?.path ?? "/en/stepCountChangeDevice",
    meta: stepCountChangeDevicecJxXov1yQbMeta || {},
    alias: stepCountChangeDevicecJxXov1yQbMeta?.alias || [],
    redirect: stepCountChangeDevicecJxXov1yQbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountChangeDevice.vue").then(m => m.default || m)
  },
  {
    name: stepCountChangeDevicecJxXov1yQbMeta?.name ?? "stepCountChangeDevice___tc",
    path: stepCountChangeDevicecJxXov1yQbMeta?.path ?? "/tc/stepCountChangeDevice",
    meta: stepCountChangeDevicecJxXov1yQbMeta || {},
    alias: stepCountChangeDevicecJxXov1yQbMeta?.alias || [],
    redirect: stepCountChangeDevicecJxXov1yQbMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountChangeDevice.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectIntroOEUwHh3fKSMeta?.name ?? "stepCountConnectIntro___en___default",
    path: stepCountConnectIntroOEUwHh3fKSMeta?.path ?? "/stepCountConnectIntro",
    meta: stepCountConnectIntroOEUwHh3fKSMeta || {},
    alias: stepCountConnectIntroOEUwHh3fKSMeta?.alias || [],
    redirect: stepCountConnectIntroOEUwHh3fKSMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectIntro.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectIntroOEUwHh3fKSMeta?.name ?? "stepCountConnectIntro___en",
    path: stepCountConnectIntroOEUwHh3fKSMeta?.path ?? "/en/stepCountConnectIntro",
    meta: stepCountConnectIntroOEUwHh3fKSMeta || {},
    alias: stepCountConnectIntroOEUwHh3fKSMeta?.alias || [],
    redirect: stepCountConnectIntroOEUwHh3fKSMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectIntro.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectIntroOEUwHh3fKSMeta?.name ?? "stepCountConnectIntro___tc",
    path: stepCountConnectIntroOEUwHh3fKSMeta?.path ?? "/tc/stepCountConnectIntro",
    meta: stepCountConnectIntroOEUwHh3fKSMeta || {},
    alias: stepCountConnectIntroOEUwHh3fKSMeta?.alias || [],
    redirect: stepCountConnectIntroOEUwHh3fKSMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectIntro.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectListxKHEc7Nw3SMeta?.name ?? "stepCountConnectList___en___default",
    path: stepCountConnectListxKHEc7Nw3SMeta?.path ?? "/stepCountConnectList",
    meta: stepCountConnectListxKHEc7Nw3SMeta || {},
    alias: stepCountConnectListxKHEc7Nw3SMeta?.alias || [],
    redirect: stepCountConnectListxKHEc7Nw3SMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectList.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectListxKHEc7Nw3SMeta?.name ?? "stepCountConnectList___en",
    path: stepCountConnectListxKHEc7Nw3SMeta?.path ?? "/en/stepCountConnectList",
    meta: stepCountConnectListxKHEc7Nw3SMeta || {},
    alias: stepCountConnectListxKHEc7Nw3SMeta?.alias || [],
    redirect: stepCountConnectListxKHEc7Nw3SMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectList.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectListxKHEc7Nw3SMeta?.name ?? "stepCountConnectList___tc",
    path: stepCountConnectListxKHEc7Nw3SMeta?.path ?? "/tc/stepCountConnectList",
    meta: stepCountConnectListxKHEc7Nw3SMeta || {},
    alias: stepCountConnectListxKHEc7Nw3SMeta?.alias || [],
    redirect: stepCountConnectListxKHEc7Nw3SMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnectList.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectedsBiDYHv5YHMeta?.name ?? "stepCountConnected___en___default",
    path: stepCountConnectedsBiDYHv5YHMeta?.path ?? "/stepCountConnected",
    meta: stepCountConnectedsBiDYHv5YHMeta || {},
    alias: stepCountConnectedsBiDYHv5YHMeta?.alias || [],
    redirect: stepCountConnectedsBiDYHv5YHMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectedsBiDYHv5YHMeta?.name ?? "stepCountConnected___en",
    path: stepCountConnectedsBiDYHv5YHMeta?.path ?? "/en/stepCountConnected",
    meta: stepCountConnectedsBiDYHv5YHMeta || {},
    alias: stepCountConnectedsBiDYHv5YHMeta?.alias || [],
    redirect: stepCountConnectedsBiDYHv5YHMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountConnectedsBiDYHv5YHMeta?.name ?? "stepCountConnected___tc",
    path: stepCountConnectedsBiDYHv5YHMeta?.path ?? "/tc/stepCountConnected",
    meta: stepCountConnectedsBiDYHv5YHMeta || {},
    alias: stepCountConnectedsBiDYHv5YHMeta?.alias || [],
    redirect: stepCountConnectedsBiDYHv5YHMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountDisconnectedxSHVfZoJL9Meta?.name ?? "stepCountDisconnected___en___default",
    path: stepCountDisconnectedxSHVfZoJL9Meta?.path ?? "/stepCountDisconnected",
    meta: stepCountDisconnectedxSHVfZoJL9Meta || {},
    alias: stepCountDisconnectedxSHVfZoJL9Meta?.alias || [],
    redirect: stepCountDisconnectedxSHVfZoJL9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountDisconnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountDisconnectedxSHVfZoJL9Meta?.name ?? "stepCountDisconnected___en",
    path: stepCountDisconnectedxSHVfZoJL9Meta?.path ?? "/en/stepCountDisconnected",
    meta: stepCountDisconnectedxSHVfZoJL9Meta || {},
    alias: stepCountDisconnectedxSHVfZoJL9Meta?.alias || [],
    redirect: stepCountDisconnectedxSHVfZoJL9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountDisconnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountDisconnectedxSHVfZoJL9Meta?.name ?? "stepCountDisconnected___tc",
    path: stepCountDisconnectedxSHVfZoJL9Meta?.path ?? "/tc/stepCountDisconnected",
    meta: stepCountDisconnectedxSHVfZoJL9Meta || {},
    alias: stepCountDisconnectedxSHVfZoJL9Meta?.alias || [],
    redirect: stepCountDisconnectedxSHVfZoJL9Meta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountDisconnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountGarminConnected0DX7mE7VLPMeta?.name ?? "stepCountGarminConnected___en___default",
    path: stepCountGarminConnected0DX7mE7VLPMeta?.path ?? "/stepCountGarminConnected",
    meta: stepCountGarminConnected0DX7mE7VLPMeta || {},
    alias: stepCountGarminConnected0DX7mE7VLPMeta?.alias || [],
    redirect: stepCountGarminConnected0DX7mE7VLPMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountGarminConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountGarminConnected0DX7mE7VLPMeta?.name ?? "stepCountGarminConnected___en",
    path: stepCountGarminConnected0DX7mE7VLPMeta?.path ?? "/en/stepCountGarminConnected",
    meta: stepCountGarminConnected0DX7mE7VLPMeta || {},
    alias: stepCountGarminConnected0DX7mE7VLPMeta?.alias || [],
    redirect: stepCountGarminConnected0DX7mE7VLPMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountGarminConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountGarminConnected0DX7mE7VLPMeta?.name ?? "stepCountGarminConnected___tc",
    path: stepCountGarminConnected0DX7mE7VLPMeta?.path ?? "/tc/stepCountGarminConnected",
    meta: stepCountGarminConnected0DX7mE7VLPMeta || {},
    alias: stepCountGarminConnected0DX7mE7VLPMeta?.alias || [],
    redirect: stepCountGarminConnected0DX7mE7VLPMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountGarminConnected.vue").then(m => m.default || m)
  },
  {
    name: stepCountIntroi6psBPi60AMeta?.name ?? "stepCountIntro___en___default",
    path: stepCountIntroi6psBPi60AMeta?.path ?? "/stepCountIntro",
    meta: stepCountIntroi6psBPi60AMeta || {},
    alias: stepCountIntroi6psBPi60AMeta?.alias || [],
    redirect: stepCountIntroi6psBPi60AMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountIntro.vue").then(m => m.default || m)
  },
  {
    name: stepCountIntroi6psBPi60AMeta?.name ?? "stepCountIntro___en",
    path: stepCountIntroi6psBPi60AMeta?.path ?? "/en/stepCountIntro",
    meta: stepCountIntroi6psBPi60AMeta || {},
    alias: stepCountIntroi6psBPi60AMeta?.alias || [],
    redirect: stepCountIntroi6psBPi60AMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountIntro.vue").then(m => m.default || m)
  },
  {
    name: stepCountIntroi6psBPi60AMeta?.name ?? "stepCountIntro___tc",
    path: stepCountIntroi6psBPi60AMeta?.path ?? "/tc/stepCountIntro",
    meta: stepCountIntroi6psBPi60AMeta || {},
    alias: stepCountIntroi6psBPi60AMeta?.alias || [],
    redirect: stepCountIntroi6psBPi60AMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stepCountIntro.vue").then(m => m.default || m)
  },
  {
    name: stretch0dYh64TgGTMeta?.name ?? "stretch___en___default",
    path: stretch0dYh64TgGTMeta?.path ?? "/stretch",
    meta: stretch0dYh64TgGTMeta || {},
    alias: stretch0dYh64TgGTMeta?.alias || [],
    redirect: stretch0dYh64TgGTMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretch.vue").then(m => m.default || m)
  },
  {
    name: stretch0dYh64TgGTMeta?.name ?? "stretch___en",
    path: stretch0dYh64TgGTMeta?.path ?? "/en/stretch",
    meta: stretch0dYh64TgGTMeta || {},
    alias: stretch0dYh64TgGTMeta?.alias || [],
    redirect: stretch0dYh64TgGTMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretch.vue").then(m => m.default || m)
  },
  {
    name: stretch0dYh64TgGTMeta?.name ?? "stretch___tc",
    path: stretch0dYh64TgGTMeta?.path ?? "/tc/stretch",
    meta: stretch0dYh64TgGTMeta || {},
    alias: stretch0dYh64TgGTMeta?.alias || [],
    redirect: stretch0dYh64TgGTMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretch.vue").then(m => m.default || m)
  },
  {
    name: stretchTestJR4C8A5r3dMeta?.name ?? "stretchTest___en___default",
    path: stretchTestJR4C8A5r3dMeta?.path ?? "/stretchTest",
    meta: stretchTestJR4C8A5r3dMeta || {},
    alias: stretchTestJR4C8A5r3dMeta?.alias || [],
    redirect: stretchTestJR4C8A5r3dMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretchTest.vue").then(m => m.default || m)
  },
  {
    name: stretchTestJR4C8A5r3dMeta?.name ?? "stretchTest___en",
    path: stretchTestJR4C8A5r3dMeta?.path ?? "/en/stretchTest",
    meta: stretchTestJR4C8A5r3dMeta || {},
    alias: stretchTestJR4C8A5r3dMeta?.alias || [],
    redirect: stretchTestJR4C8A5r3dMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretchTest.vue").then(m => m.default || m)
  },
  {
    name: stretchTestJR4C8A5r3dMeta?.name ?? "stretchTest___tc",
    path: stretchTestJR4C8A5r3dMeta?.path ?? "/tc/stretchTest",
    meta: stretchTestJR4C8A5r3dMeta || {},
    alias: stretchTestJR4C8A5r3dMeta?.alias || [],
    redirect: stretchTestJR4C8A5r3dMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/stretchTest.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsoOl0T86Y7QMeta?.name ?? "terms-and-conditions___en___default",
    path: terms_45and_45conditionsoOl0T86Y7QMeta?.path ?? "/terms-and-conditions",
    meta: terms_45and_45conditionsoOl0T86Y7QMeta || {},
    alias: terms_45and_45conditionsoOl0T86Y7QMeta?.alias || [],
    redirect: terms_45and_45conditionsoOl0T86Y7QMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsoOl0T86Y7QMeta?.name ?? "terms-and-conditions___en",
    path: terms_45and_45conditionsoOl0T86Y7QMeta?.path ?? "/en/terms-and-conditions",
    meta: terms_45and_45conditionsoOl0T86Y7QMeta || {},
    alias: terms_45and_45conditionsoOl0T86Y7QMeta?.alias || [],
    redirect: terms_45and_45conditionsoOl0T86Y7QMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsoOl0T86Y7QMeta?.name ?? "terms-and-conditions___tc",
    path: terms_45and_45conditionsoOl0T86Y7QMeta?.path ?? "/tc/terms-and-conditions",
    meta: terms_45and_45conditionsoOl0T86Y7QMeta || {},
    alias: terms_45and_45conditionsoOl0T86Y7QMeta?.alias || [],
    redirect: terms_45and_45conditionsoOl0T86Y7QMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: tncmCmlhL6PlwMeta?.name ?? "tnc___en___default",
    path: tncmCmlhL6PlwMeta?.path ?? "/tnc",
    meta: tncmCmlhL6PlwMeta || {},
    alias: tncmCmlhL6PlwMeta?.alias || [],
    redirect: tncmCmlhL6PlwMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/tnc.vue").then(m => m.default || m)
  },
  {
    name: tncmCmlhL6PlwMeta?.name ?? "tnc___en",
    path: tncmCmlhL6PlwMeta?.path ?? "/en/tnc",
    meta: tncmCmlhL6PlwMeta || {},
    alias: tncmCmlhL6PlwMeta?.alias || [],
    redirect: tncmCmlhL6PlwMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/tnc.vue").then(m => m.default || m)
  },
  {
    name: tncmCmlhL6PlwMeta?.name ?? "tnc___tc",
    path: tncmCmlhL6PlwMeta?.path ?? "/tc/tnc",
    meta: tncmCmlhL6PlwMeta || {},
    alias: tncmCmlhL6PlwMeta?.alias || [],
    redirect: tncmCmlhL6PlwMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/tnc.vue").then(m => m.default || m)
  },
  {
    name: vitalResultm6JhYmZflfMeta?.name ?? "vitalResult___en___default",
    path: vitalResultm6JhYmZflfMeta?.path ?? "/vitalResult",
    meta: vitalResultm6JhYmZflfMeta || {},
    alias: vitalResultm6JhYmZflfMeta?.alias || [],
    redirect: vitalResultm6JhYmZflfMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResult.vue").then(m => m.default || m)
  },
  {
    name: vitalResultm6JhYmZflfMeta?.name ?? "vitalResult___en",
    path: vitalResultm6JhYmZflfMeta?.path ?? "/en/vitalResult",
    meta: vitalResultm6JhYmZflfMeta || {},
    alias: vitalResultm6JhYmZflfMeta?.alias || [],
    redirect: vitalResultm6JhYmZflfMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResult.vue").then(m => m.default || m)
  },
  {
    name: vitalResultm6JhYmZflfMeta?.name ?? "vitalResult___tc",
    path: vitalResultm6JhYmZflfMeta?.path ?? "/tc/vitalResult",
    meta: vitalResultm6JhYmZflfMeta || {},
    alias: vitalResultm6JhYmZflfMeta?.alias || [],
    redirect: vitalResultm6JhYmZflfMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResult.vue").then(m => m.default || m)
  },
  {
    name: vitalResultDetailPZQAZcipmBMeta?.name ?? "vitalResultDetail___en___default",
    path: vitalResultDetailPZQAZcipmBMeta?.path ?? "/vitalResultDetail",
    meta: vitalResultDetailPZQAZcipmBMeta || {},
    alias: vitalResultDetailPZQAZcipmBMeta?.alias || [],
    redirect: vitalResultDetailPZQAZcipmBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResultDetail.vue").then(m => m.default || m)
  },
  {
    name: vitalResultDetailPZQAZcipmBMeta?.name ?? "vitalResultDetail___en",
    path: vitalResultDetailPZQAZcipmBMeta?.path ?? "/en/vitalResultDetail",
    meta: vitalResultDetailPZQAZcipmBMeta || {},
    alias: vitalResultDetailPZQAZcipmBMeta?.alias || [],
    redirect: vitalResultDetailPZQAZcipmBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResultDetail.vue").then(m => m.default || m)
  },
  {
    name: vitalResultDetailPZQAZcipmBMeta?.name ?? "vitalResultDetail___tc",
    path: vitalResultDetailPZQAZcipmBMeta?.path ?? "/tc/vitalResultDetail",
    meta: vitalResultDetailPZQAZcipmBMeta || {},
    alias: vitalResultDetailPZQAZcipmBMeta?.alias || [],
    redirect: vitalResultDetailPZQAZcipmBMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalResultDetail.vue").then(m => m.default || m)
  },
  {
    name: vitalScantuGqe0PARyMeta?.name ?? "vitalScan___en___default",
    path: vitalScantuGqe0PARyMeta?.path ?? "/vitalScan",
    meta: vitalScantuGqe0PARyMeta || {},
    alias: vitalScantuGqe0PARyMeta?.alias || [],
    redirect: vitalScantuGqe0PARyMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScan.vue").then(m => m.default || m)
  },
  {
    name: vitalScantuGqe0PARyMeta?.name ?? "vitalScan___en",
    path: vitalScantuGqe0PARyMeta?.path ?? "/en/vitalScan",
    meta: vitalScantuGqe0PARyMeta || {},
    alias: vitalScantuGqe0PARyMeta?.alias || [],
    redirect: vitalScantuGqe0PARyMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScan.vue").then(m => m.default || m)
  },
  {
    name: vitalScantuGqe0PARyMeta?.name ?? "vitalScan___tc",
    path: vitalScantuGqe0PARyMeta?.path ?? "/tc/vitalScan",
    meta: vitalScantuGqe0PARyMeta || {},
    alias: vitalScantuGqe0PARyMeta?.alias || [],
    redirect: vitalScantuGqe0PARyMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScan.vue").then(m => m.default || m)
  },
  {
    name: vitalScanDis4w1UeRXroAMeta?.name ?? "vitalScanDis___en___default",
    path: vitalScanDis4w1UeRXroAMeta?.path ?? "/vitalScanDis",
    meta: vitalScanDis4w1UeRXroAMeta || {},
    alias: vitalScanDis4w1UeRXroAMeta?.alias || [],
    redirect: vitalScanDis4w1UeRXroAMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanDis.vue").then(m => m.default || m)
  },
  {
    name: vitalScanDis4w1UeRXroAMeta?.name ?? "vitalScanDis___en",
    path: vitalScanDis4w1UeRXroAMeta?.path ?? "/en/vitalScanDis",
    meta: vitalScanDis4w1UeRXroAMeta || {},
    alias: vitalScanDis4w1UeRXroAMeta?.alias || [],
    redirect: vitalScanDis4w1UeRXroAMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanDis.vue").then(m => m.default || m)
  },
  {
    name: vitalScanDis4w1UeRXroAMeta?.name ?? "vitalScanDis___tc",
    path: vitalScanDis4w1UeRXroAMeta?.path ?? "/tc/vitalScanDis",
    meta: vitalScanDis4w1UeRXroAMeta || {},
    alias: vitalScanDis4w1UeRXroAMeta?.alias || [],
    redirect: vitalScanDis4w1UeRXroAMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanDis.vue").then(m => m.default || m)
  },
  {
    name: vitalScanOriginalkRdMcdCBgvMeta?.name ?? "vitalScanOriginal___en___default",
    path: vitalScanOriginalkRdMcdCBgvMeta?.path ?? "/vitalScanOriginal",
    meta: vitalScanOriginalkRdMcdCBgvMeta || {},
    alias: vitalScanOriginalkRdMcdCBgvMeta?.alias || [],
    redirect: vitalScanOriginalkRdMcdCBgvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanOriginal.vue").then(m => m.default || m)
  },
  {
    name: vitalScanOriginalkRdMcdCBgvMeta?.name ?? "vitalScanOriginal___en",
    path: vitalScanOriginalkRdMcdCBgvMeta?.path ?? "/en/vitalScanOriginal",
    meta: vitalScanOriginalkRdMcdCBgvMeta || {},
    alias: vitalScanOriginalkRdMcdCBgvMeta?.alias || [],
    redirect: vitalScanOriginalkRdMcdCBgvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanOriginal.vue").then(m => m.default || m)
  },
  {
    name: vitalScanOriginalkRdMcdCBgvMeta?.name ?? "vitalScanOriginal___tc",
    path: vitalScanOriginalkRdMcdCBgvMeta?.path ?? "/tc/vitalScanOriginal",
    meta: vitalScanOriginalkRdMcdCBgvMeta || {},
    alias: vitalScanOriginalkRdMcdCBgvMeta?.alias || [],
    redirect: vitalScanOriginalkRdMcdCBgvMeta?.redirect || undefined,
    component: () => import("/github/workspace/pages/vitalScanOriginal.vue").then(m => m.default || m)
  }
]